import { parseBoolean } from "@";

// search values payload
export const searchValuesPayload = ({
  page,
  title,
  perSize,
  isDonor,
  donorStatus,
  stopMessageGroup,
}) => ({
  page,
  searchKey: title,
  pageSize: perSize,
  isDonor: parseBoolean(isDonor),
  isActive: parseBoolean(donorStatus),
  isAcceptGroupMessages: parseBoolean(stopMessageGroup),
});
